import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { SectionFormValues } from '../../types/Section.types';
import FormGroup from '../../components/Form/FormGroup';
import Input from '../../components/Form/Input';
import Button from '../../components/Form/Button';
import Box from '../../components/Box';
import Heading from '../../components/Text/Heading';
import { StyledForm } from './styles';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import TextArea from '../../components/Form/TextArea';
import { DialogCancelCreateUpdate } from '../shared/DialogCancelCreateUpdate';

interface SectionFormProps {
  type: 'create' | 'update' | 'view';
  initialData?: SectionFormValues;
  onSubmit: (data: SectionFormValues) => void;
}

const validationSchema = yup.object({
  name: yup.string().required('O campo nome é obrigatório'),
});

const SectionForm = ({ type, initialData, onSubmit }: SectionFormProps) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<SectionFormValues>({
    defaultValues: initialData,
    resolver: yupResolver(validationSchema),
  });

  const navigate = useNavigate();
  const navigateToSections = useCallback(() => {
    navigate('/sections');
  }, []);

  const title = {
    create: 'Cadastro de seção',
    update: 'Editar seção',
    view: 'Visualizar seção',
  };

  return (
    <>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <Box
          footer={
            type === 'create' || type === 'update' ? (
              <>
                <DialogCancelCreateUpdate type={type} navigateToListPage={navigateToSections} />

                <Button className="submit-button" type="submit">
                  Salvar
                </Button>
              </>
            ) : (
              <Button className="cancel-button" kind="alert" onClick={navigateToSections}>
                Voltar
              </Button>
            )
          }>
          <div className="content">
            <Heading>{title[type]}</Heading>
            <FormGroup error={errors.name?.message}>
              <Input {...register('name')} label="Título da seção" disabled={type === 'view' ? true : false} />
            </FormGroup>
            <FormGroup error={errors.description?.message}>
              <TextArea
                {...register('description')}
                label="Descrição da seção"
                disabled={type === 'view' ? true : false}
              />
            </FormGroup>
          </div>
        </Box>
      </StyledForm>
    </>
  );
};

export default SectionForm;
